import showdown from 'showdown';

import { BiasedWord } from '@/types/common';

export const downloadFile = (content: string) => {
    saveMarkdownAsPDF(content, `bias-analysis-${new Date().toISOString()}`);
    // downloadMarkdown(content, `bias-analysis-${new Date().toISOString()}.md`);
};

const downloadMarkdown = (content: string, title: string) => {
    const blob = new Blob([content], {
        type: 'text/markdown;charset=utf-8',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = title;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

const convertContentToHtml = (content: string): string => {
    const converter = new showdown.Converter();
    converter.setOption('tables', true);
    return converter.makeHtml(content);
};

const createHTMLFromContent = (
    content: string,
    title: string,
    customContent?: string,
    customStyles?: string
): string => {
    return /* HTML */ `
        <!DOCTYPE html>
        <html>
            <head>
                <title>${title}</title>
                <style>
                    @media print {
                        body {
                            font-size: 12pt;
                            color: #222;
                            margin: 10px;
                            padding-top: 10px;
                        }
                        .divider {
                            color: #000000;
                            margin: 10px 0;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }
                        table th,
                        table td {
                            border: 1px solid #000;
                            padding: 8px;
                            text-align: left;
                        }
                        table th {
                            background-color: #f2f2f2;
                        }
                        .role-you {
                            color: #5158e2;
                            display: flex;
                            align-items: center;
                        }
                        .role-gpt {
                            color: #1e3b4e;
                            display: flex;
                            align-items: center;
                        }
                        .role-you img,
                        .role-gpt img {
                            border-radius: 50%;
                        }
                        ${customStyles ?? ''}
                    }
                </style>
            </head>
            <body>
                ${customContent ?? ''} ${content}
            </body>
        </html>
    `;
};

const saveHTMLAsPDF = (html: string): void => {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    iframe.onload = () => {
        try {
            iframe?.contentWindow?.print();
        } catch (error) {
            console.error('Printing failed:', error);
        }
    };

    iframe?.contentDocument?.write(html);
    iframe?.contentDocument?.close();
};

const saveMarkdownAsPDF = (
    markdownContent: string,
    title: string,
    customContent?: string,
    customStyles?: string
): void => {
    const htmlContent = convertContentToHtml(markdownContent);
    const html = createHTMLFromContent(
        htmlContent,
        title,
        customContent,
        customStyles
    );
    saveHTMLAsPDF(html);
};

export function formatBiasedWords(biasedWords: BiasedWord[]): string {
    return biasedWords
        .map((bw) => {
            const uniqueReasons = Array.from(new Set(bw.reasons));
            const uniqueLabels = Array.from(new Set(bw.labels));
            return `Word: "${bw.word}" (Index: ${
                bw.index
            })\nReasons: ${uniqueReasons.join(
                ', '
            )}\nLabels: ${uniqueLabels.join(', ')}\n`;
        })
        .join('\n');
}
